import { Account_State } from '@fireworks/generated-protos/fireworks_protos/gateway/account_pb';
import { NeverError } from '@fireworks/lib';
import { GATEWAY_URL, IS_NODE_POOL_UI_ENABLED } from '../config';
import { AccountType } from '../types/account_type';

export type Feature = 'nodePoolUI' | 'billing' | 'usage' | 'fullfillPaymentFromWebhook';
export interface Session {
  email: string;
  accountType?: AccountType | undefined;
  accountState?: Account_State;
}

export function isInternalUser(email: string): boolean {
  return email.endsWith('@fireworks.ai') || email.endsWith('@fireworks-ai.dev');
}

export const isFeatureEnabled = (feature: Feature, session?: Session | null): boolean => {
  if (!session) return false;

  switch (feature) {
    case 'nodePoolUI':
      return IS_NODE_POOL_UI_ENABLED ?? GATEWAY_URL !== 'https://gateway.fireworks.ai/web';
    case 'billing':
      return session.accountType !== AccountType.Enterprise;
    case 'usage':
      return session.accountType === AccountType.Enterprise;
    case 'fullfillPaymentFromWebhook':
      return true;
    default:
      throw new NeverError(feature);
  }
};
